<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="580" scrollable persistent>
      <v-card class="rounded-lg">
        <v-card-text style="text-align: center; padding-top: 30px">
          <img
            height="100"
            width="100"
            :src="require('@/assets/img/networking.png')"
          />
          <h2 class="pt-3">เพิ่มข้อมูล User Group</h2>
          <v-layout row wrap justify-center align-center pt-9>
            <v-flex xs10 sm10 md10 lg10>
              <b class="red--text" style="font-size: 16px">
                หมายเหตุ​ : ค่าเริ่มต้นของ User Group จะเป็น General
              </b>
              <br />
              <b class="red--text">
                หากต้องการแก้ไขข้อมูลสามารถทำรายการด้านล่าง</b
              >
            </v-flex>

            <v-flex xs10 sm10 md10 lg10 pt-3>
              <v-btn outlined rounded color="info" @click="fn_addUserGroup">
                เพิ่ม User Group
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-center align-center v-if="ShowInput">
            <v-flex xs9 sm9 md9 lg9 pt-5>
              <v-autocomplete
                label="User Group"
                outlined
                dense
                color="#077893"
                :items="ItemsUserGroup"
                :filter="customFilter"
                v-model="UserGroup"
                append-icon="mdi-account-supervisor-outline"
                autocomplete
                ><template v-slot:no-data>
                  <div style="font-size: 12px" class="pa-4">
                    ไม่พบข้อมูลในระบบ
                  </div>
                  <v-divider></v-divider>
                  <v-list-item color="#077893" @click="fn_save()">
                    <v-list-item-icon
                      ><v-icon color="black">mdi-plus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-left">
                        เพิ่ม User Group
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template></v-autocomplete
              >
            </v-flex>
            <v-flex xs1 sm1 md1 lg1>
              <v-btn
                dark
                right
                fab
                color="red"
                x-small
                @click="ShowInput = false"
              >
                <v-icon>mdi-minus</v-icon>
              </v-btn></v-flex
            >
          </v-layout>
        </v-card-text>
        <v-card-actions style="justify-content: center" class="pb-5 pt-6">
          <v-btn
            color="#077893"
            dark
            dense
            :loading="LoadingSubmit"
            @click="fn_save()"
          >
            {{ $t("smtp.text12") }}
          </v-btn>
          <v-btn color="red" text @click="fn_close()">
            {{ $t("smtp.text11") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show"],
  data: function () {
    return {
      UserGroup: "",
      NewUserGroup: "",
      LoadingSubmit: false,
      ShowInput: false,
      ItemsUserGroup: [],
    };
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogAdd");
        }
      },
    },
  },
  methods: {
    fn_addUserGroup() {
      this.fn_getUSerGroup();
      this.ShowInput = true;
    },
    fn_save() {
      if (this.NewUserGroup) {
        this.$emit("submitFile", this.NewUserGroup);
      } else if (this.UserGroup || this.UserGroup == "") {
        this.$emit("submitFile", this.UserGroup);
      }
    },
    fn_close() {
      this.$emit("closeDialogAdd");
    },
    async fn_getUSerGroup() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/GetGroupUserEmail",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemsUserGroup = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    customFilter(item, queryText, itemText) {
      this.NewUserGroup = "";
      this.NewUserGroup = queryText;
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.UserGroup = "";
        this.NewUserGroup = "";
        this.ShowInput = false;
      }
    },
  },
};
</script>
